import styled from 'styled-components';

export default styled.div`
  dispay: flex;
  position: relative;
`;
